var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(_vm.replied)?[_c('v-alert',{attrs:{"type":_vm.error ? 'error' : 'success',"border":"top"}},[_vm._v(" "+_vm._s(_vm.message)+" ")])]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }